import { render, staticRenderFns } from "./JM.vue?vue&type=template&id=11f2de8b&scoped=true"
import script from "./JM.vue?vue&type=script&lang=js"
export * from "./JM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f2de8b",
  null
  
)

export default component.exports